export default "__VITE_ASSET__CWHTGRfP__"